import React, { useEffect, useState } from 'react'

import './App.css'
import { useNavigate } from 'react-router-dom';
import { AddIconButton, EditIconButton, InviteButton } from '../../../ButtonsIconsInputs/IconButtons';
import DeleteConfirmation from '../../reusableComp/Deletecomfirmation';
import Heading from '../../reusableComp/Heading';
import { InputBox } from '../../../ButtonsIconsInputs/CustomInputs';
import DataTable from './DataTable';
import EditModal from './EditModal';
import StanderdConstants from '../../../services/StanderdConstants';
import CreateAssessmentSeries from './CreateAssessmentSeries';
import useUserId from '../../../services/useUserId';

function AssessmentSeries() {
    const [Data, SetData] = useState([]);
    const [open, setopen] = useState(false);
    const [insertionStatus, setInsertionStatus] = useState(false);
    const [editStatus, setEditStatus] = useState(false);
    const [filteredData, setfilteredData] = useState([]);
    const [editOpen, setEditOpen] = useState(false);
    const [currentDatarow, setcurrentDatarow] = useState(null);
    const api_url = process.env.REACT_APP_API_URL
    const navigate = useNavigate()
    const [query, setQuery] = useState('');
    const [Loading,setLoading]=useState(false)

const UserId=useUserId()

    useEffect(() => {
        if (insertionStatus) {
            getAssessmentSeries()
            setInsertionStatus(false);
        }
    }, [insertionStatus, Data]);


    const handleopen = () => { setopen(true); }
    const handleclose = () => { setopen(false); }
    const handleEditOpen = (Data, index) => {
        setcurrentDatarow(Data); setEditOpen(true);

    }
    const handleEditClose = () => { setEditOpen(false); setcurrentDatarow(null);  }

    const handleDelete = async (item) => {
        let Id = Object.values(item)[0]
        

        const res = await fetch(`${api_url}/assessmentseries/Delete/?seriesId=${Id}`, {
            method: 'DELETE',
            headers: { 'Content-Type': "application/json" },
        });
        if (res.ok) {
            setInsertionStatus(true);
        } else {
        }
    }






    const AssessmentActions = [
        {
            label: StanderdConstants.EDIT_LABEL,
            handler: handleEditOpen,
            tooltip: StanderdConstants.EDIT_LABEL,
            ButtonComponent: EditIconButton,
        },
        {
            label: StanderdConstants.DELETE_LABEL,
            handler: handleDelete,
            tooltip: StanderdConstants.DELETE_LABEL,
            ButtonComponent: DeleteConfirmation,

        },
        {
            label:'Invite',
            handler:(item)=>{navigate('/InviteCandidate',{state:{content:item}})},
            ButtonComponent:InviteButton,
            tooltip:'Invite Candidates',
            // requiredPermission:permissionsNameForThisPage.Invite

        }

    ];




    const getAssessmentSeries = async () => {
        setLoading(true)
        try {
            const result = await fetch(`${process.env.REACT_APP_API_URL}/assessmentseries/getData`, {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId: UserId })

            });
            const response = await result.json();
            if (result.ok) {
                SetData(response.data)
                setfilteredData(response.data)
                setLoading(false)
            }
            else{
                setLoading(false)
            }

        } catch (error) {
            setLoading(false)
        }
    };

    useEffect(() => {
        getAssessmentSeries();
    }, []);



    useEffect(() => {
        if (editStatus) {
            getAssessmentSeries()
            setEditStatus(false)
        }
    }, [editStatus]);

    const columns = [
        { header: StanderdConstants.SERIES_HEADER_NAME, field: StanderdConstants.ASSESSMENTSERIESTABLE_COLOUMN_SERIESNAME },
        { header: StanderdConstants.ASSESSMENT_TABLEHEADER, field: StanderdConstants.ASSESSMENT_TABLE_COLUMN_ASSESSMENTNAME }
    ];

    const handleSearch = (e) => {
       
        const searchQuery = e.target.value.toLowerCase();
        setQuery(searchQuery);
        if (!searchQuery) {
            setfilteredData(Data);
        } else {
            const result = Data.filter(row =>
                Object.values(row) // Get all values from the object (row)
                    .some(value =>
                        value?.toString().toLowerCase().includes(searchQuery.toLowerCase()) // Check if any value contains the search query
                    )
            );
            setfilteredData(result);
        }
    }

    return (
        <div className="container mx-auto py-8 px-2">
            <Heading heading={"Create Assessment Series"} />
            <div className="flex flex-row  justify-between space-x-2 my-2 ">
                <div className="flex items-center space-x-2">
                    <InputBox
                        inputId='searchOrg'
                        inputLabel="Search Assessments"
                        inputValueValue={query}
                        onChange={handleSearch}
                        className="border p-2 rounded-lg"
                        type="text"
                    />

                </div>
                {<div>
                    <AddIconButton action={() => handleopen(true)} id={"addRoleMenu"} tooltip='Add new role' />
                    {open && <CreateAssessmentSeries handleclose={handleclose} setStatus={setInsertionStatus} />}

                </div>}

            </div>
{        !Loading?   ( <DataTable Data={filteredData} columns={columns} actions={AssessmentActions} />):(<div className='text-center'>...Loading</div>)
}



            {editOpen && (
                <EditModal
                    Data={currentDatarow}
                    handleClose={handleEditClose}
                    setStatus={setEditStatus} />
            )}
        </div>

    )

}

export default AssessmentSeries